<template>
  <span class="card-pin-unpin-button">
    <v-list-item class="text-center">
      <v-menu offset-y>
        <template v-slot:activator="{}">
          <v-btn
            :id="`${idPrefix}_Pin`"
            icon
            class="pin-unpin-button"
            @click.stop="pinUnpinCard($event)"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on, attr }">
                <v-icon
                  v-bind="attr"
                  :class="isPinned ? 'unpin_icon' : ''"
                  v-on="on"
                >
                  push_pin
                </v-icon>
              </template>
              <span :id="`${idPrefix}_Pin_Tooltip`"
                >{{
                  isPinned
                    ? 'Unpin this card from my dashboard'
                    : 'Pin this card to my dashboard'
                }}
              </span>
            </v-tooltip>
          </v-btn>
        </template>
      </v-menu>
    </v-list-item>
  </span>
</template>
<script>
import { put, sendDelete } from '../utility/fetch.js';

export default {
  name: 'PinUnpinButton',
  props: {
    cardName: {
      type: String,
      default: '',
    },
    idPrefix: {
      type: String,
      default: 'DashboardCard_',
    },
    pinParameters: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      count: 0,
    };
  },
  computed: {
    isPinned() {
      for (let { CardName, Parameters } of this.SBUserCards) {
        if (CardName === this.cardName && Parameters === this.stringParams) {
          return true;
        }
      }
      return false;
    },
    displayCardOrder() {
      let cardObj = null;
      if (this.SBUserCards.length > 0) {
        cardObj = this.SBUserCards.filter(
          (card) =>
            card.CardName === this.cardName &&
            card.Parameters === this.stringParams
        )[0];
      }
      return cardObj != null ? cardObj.DisplayOrder : 0;
    },
    SBUserCards() {
      return this.$store.getters.userDashboardCards;
    },
    /**
     * A stringified version of the parameters object, or an empty string if it
     * is an empty object. This value is used to save card context to the
     * database and to compare against the current DB cards
     */
    stringParams() {
      // eslint-disable-next-line no-unused-vars
      const { displayOrder, ...otherProps } = this.pinParameters;
      if (Object.keys(otherProps).length === 0) {
        return '';
      }
      return JSON.stringify(otherProps);
    },
  },
  methods: {
    async togglePin() {
      if (!this.isPinned) {
        //pin card
        if (this.count == 0) {
          this.count++;
          var retVal = await put(`/Dashboard/PinCard`, undefined, {
            cardName: this.cardName,
            parameters: this.stringParams,
          });
          if (retVal.length == 0) {
            //Success
            this.$emit('pinned', true);
          } else {
            //Exception from Controller
            this.$emit('pin-error', new Error(retVal));
          }
          this.count--;
        }
      }
      //unpin card
      else {
        await sendDelete(`/Dashboard/UnpinCard`, {
          displayOrder: this.displayCardOrder,
        });
        this.$emit('pinned', false);
      }
    },
    async pinUnpinCard(event) {
      event.stopPropagation;
      this.$emit('try-pin');
      await this.togglePin();
      this.$root.$emit('refresh-dashboard-cards');
      this.$store.dispatch('FETCH_USER_CARDS');
    },
  },
};
</script>
